// Le message d'erreur réel de l'API ({ error: "..." }) est bien plus utile
// pour l'admin que "Erreur 403: " (statusText est souvent vide côté fetch).
export const parseApiError = async (res: Response, fallback = 'Erreur lors de la requête'): Promise<Error> => {
  try {
    const body = await res.clone().json();
    if (body?.error) return new Error(body.error);
    if (body?.message) return new Error(body.message);
  } catch {
    // Corps non-JSON ou vide — on retombe sur le statut HTTP.
  }
  return new Error(res.statusText ? `${fallback} (${res.status} ${res.statusText})` : `${fallback} (${res.status})`);
};
